module.exports = __webpack_public_path__ + "images/home/index/templates-operation-1f29a1aa70fa61bf34326540d52abe82.png";